<template>
  <div class="login">
    <b-card class="center_card">
      <b-card-title class="title">Réinitialisation de votre mot de passe</b-card-title>
          <h4 class="sub-title" style="font-size:15px">
      Pour réinitialiser votre mot de passe,
      merci de renseigner l'email associé à votre compte Sivercoh.
          </h4>
      <b-row no-gutters>
        <b-col>
              <b-form-group
                  label-class="font-weight-bold"
                  label-size="lg"
                  label-align="left">
                <b-input-group >
                    <b-input-group-text variant="primary">
                      <i class="fas fa-user"></i>
                    </b-input-group-text>
                  <Field name="email" type="email" placeholder="Email" class="form-control" v-model="email" />
                </b-input-group>
                <ErrorMessage name="email" class="text-danger" />
              </b-form-group>

              <b-form-group
                label-class="font-weight-bold"
                label-size="lg"
                label-align="left">
                <b-input-group >
                    <b-input-group-text variant="primary">
                      <i class="fas fa-lock"></i>
                    </b-input-group-text>
                  <Field name="password" :type="showPassword ? 'text' : 'password'" placeholder="Mot de passe" minlength="8" required class="form-control" v-model="password" />
                  <b-input-group-text class="cursor-pointer" @click.prevent="toggleShowPassword">
                    <img v-if="showPassword" src="@/assets/eye-solid.svg" alt="Masquer" width="16" height="16">
                    <img v-else src="@/assets/eye-solid.svg" alt="Afficher" width="16" height="16">
                  </b-input-group-text>
                </b-input-group>
                <ErrorMessage name="password" class="text-danger" />
              </b-form-group>

          <b-form-group class="mt-3 mb-3" label-class="font-weight-bold" label-size="lg" label-align="left">
            <b-input-group>
              <b-input-group-text variant="primary">
                <i class="fas fa-lock"></i>
              </b-input-group-text>
              <Field name="mdpConfirm" :type="showConfirmPassword ? 'text' : 'password'" placeholder="Confirmer votre mot de passe" minlength="8" required class="form-control" v-model="mdpConfirm" />
              <b-input-group-text class="cursor-pointer" @click.prevent="toggleShowConfirmPassword">
                <img v-if="showConfirmPassword" src="@/assets/eye-solid.svg" alt="Masquer" width="16" height="16">
                <img v-else src="@/assets/eye-solid.svg" alt="Afficher" width="16" height="16">
              </b-input-group-text>
            </b-input-group>
            <ErrorMessage name="mdpConfirm" class="text-danger" />
          </b-form-group>

        </b-col>
      </b-row>
      <b-button pill @click = "resetPassword" class="nav-link3 m-2">Valider</b-button>
      <b-button pill class="nav-link2 m-2"><router-link to="/login" class="nav-link2">Annuler</router-link></b-button>
    </b-card>
  </div>
</template>

<script>
import http from '@/http.js'
import router from "@/router";
import { ref } from 'vue';
import { useForm, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';


export default {
  name:'resetPassword',
  components: {
    Field,
    ErrorMessage,
  },
  props: {
    token: {
      required: true,
      type: String
    },
  },
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props) {
    const email = ref('');
    const password = ref('');
    const mdpConfirm = ref('');
    const showPassword = ref(false);
    const showConfirmPassword = ref(false);

    const schema = yup.object({
      email: yup.string().email('Le format de l\'email saisi est incorrect').required('Ce champ est obligatoire'),
      password: yup.string().min(12, 'Le mot de passe doit contenir au moins 12 caractères').required('Ce champ est obligatoire').matches(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?,£;.:!@$%&^*-]).*$/, 'Le mot de passe doit contenir au moins: une minuscule, une majuscule, un chiffre et un caractère spécial.'),
      mdpConfirm: yup.string().oneOf([yup.ref('password')], 'Les mots de passe ne correspondent pas').required('Ce champ est obligatoire'),
    });

    const { handleSubmit } = useForm({
      validationSchema: schema,
    });

    const toggleShowPassword = () => {
      showPassword.value = !showPassword.value;
    };

    const toggleShowConfirmPassword = () => {
      showConfirmPassword.value = !showConfirmPassword.value;
    };

    const resetPassword = handleSubmit(async () => {
      try {
        const userExists = await http.verifUserByEmail(email.value);
        if (userExists) {
          const reinitmdpData = {
            token: props.token,
            email: email.value,
            mdp: password.value,
          };
          const response = await http.resetPassword(reinitmdpData);
          if (response === 'ok') {
            await router.push({name: 'Login'});
          }
        }
      } catch (error) {
        console.error('Erreur lors de la réinitialisation du mot de passe:', error);
      }
    });

    return {
      email,
      password,
      mdpConfirm,
      showPassword,
      showConfirmPassword,
      toggleShowPassword,
      toggleShowConfirmPassword,
      resetPassword,
    };
  },
};
</script>

<style scoped>

.hints {
  color: red;
  padding: 0.1em;
  margin: 1em 0;
  font-size: 0.9em;
}

.contraintes {
  margin: .5em 0 .2em 0;
  font-size: 0.9em;
}
.contrainte {
  margin: 0;
  padding-left: 1em;
  font-size: .9em;
  margin-right: 6px;
  display: inline-block;
}
.sub-title{
  color: white;
  font-size: 15px;
}

.title{
  color:white;
  
}
.card.center_card{
  margin:13em auto;
  width:40%;
  background-color: #00a3a6;
  color : #17a2b8;
  border:none;
}

.nav-link2{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #ed6e6c;
}
.nav-link2:hover{
  color: black !important;
}
.nav-link3{
  color: white !important;
  font-size: 15px;
  text-align: right;
  margin:auto;
  background-color: #9dc544;
}
.nav-link3:hover{
  color: black !important;
}

</style>